import { useRef, useState } from 'react';
import type { OverlayProps as BootstrapOverlayProps } from 'react-bootstrap';

import OverlayPopover from '../OverlayPopover';
import OverlayTriggerTooltip from '../OverlayTriggerTooltip';
import Pill from '../Pill';
import type { PillProps } from '../Pill';

export interface PillOverlayPopoverProps extends PillProps {
  children: React.ReactNode;
  container?: HTMLElement;
  hasArrow?: boolean;
  onHidePopover?: () => void;
  overlayClassName?: string;
  overlayPlacement?: BootstrapOverlayProps['placement'];
  overlayTestId?: string;
  pillClassName?: string;
  pillTestId?: string;
  rootCloseEvent?: BootstrapOverlayProps['rootCloseEvent'];
  tooltipContent?: React.ReactNode | string;
  tooltipPlacement?: 'bottom' | 'left' | 'right' | 'top';
}

const PillOverlayPopover = ({
  children,
  container,
  hasArrow = false,
  onHidePopover = () => {},
  overlayClassName,
  overlayPlacement = 'bottom-start',
  overlayTestId,
  pillClassName,
  pillTestId,
  rootCloseEvent,
  tooltipContent,
  tooltipPlacement,
  ...props
}: PillOverlayPopoverProps) => {
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const buttonRef = useRef<HTMLSpanElement>(null);

  return (
    <>
      <span ref={buttonRef}>
        <OverlayTriggerTooltip
          content={!isOverlayOpen ? tooltipContent : null}
          placement={tooltipPlacement}
        >
          <Pill
            className={pillClassName}
            data-testid={pillTestId}
            isActive={isOverlayOpen}
            onClick={() => {
              setIsOverlayOpen(true);
            }}
            {...props}
          />
        </OverlayTriggerTooltip>
      </span>
      <OverlayPopover
        className={overlayClassName}
        container={container}
        data-testid={overlayTestId}
        hasArrow={hasArrow}
        isActive={isOverlayOpen}
        onHide={() => {
          setIsOverlayOpen(false);
          onHidePopover();
        }}
        placement={overlayPlacement}
        rootCloseEvent={rootCloseEvent}
        target={buttonRef.current}
        {...props}
      >
        {children}
      </OverlayPopover>
    </>
  );
};

export default PillOverlayPopover;
